<template>
  <BaseDialog
    contentClass="localisation"
    ref="dialog"
    :show-actions="true"
    :persistent="isDirty"
    @closeModal="closeDialog"
    sidePanel
  >
    <template slot="title">
      {{
        isEditMode ? $t('page.admin-localisation.edit-localisation') : $t('page.admin-localisation.add-localisation')
      }}
    </template>

    <template slot="content">
      <form @submit.prevent="onSubmit" novalidate class="location-dialog__form">
        <div class="form-section">
          <FormInput
            :label="$t('page.admin-localisation.title')"
            @input="onInputChange"
            has-gray-background
            name="locationTitle"
            type="text"
            isRequired
            ref="locationTitle"
            v-model="locationTitle"
            v-validate="'required'"
          />
        </div>
        <div class="form-section">
          <FormMapSearchBox
            ref="mapSearch"
            :label="$t('page.admin-localisation.address')"
            name="locationAddress"
            :value="locationAddress"
            @input="onAddressSelected"
            isRequired
          />
        </div>

        <div class="actions">
          <FormButton
            is-large
            :disabled="isFormInvalid"
            :is-outlined="isFormInvalid"
            type="submit"
            class="location-dialog__submit"
          >
            {{ isEditMode ? $t('actions.edit') : $t('actions.add') }}
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import FormMapSearchBox from '@/components/form/FormMapSearchBox.vue';
import { mapActions } from 'vuex';

export default {
  name: 'LocationDialog',
  components: {
    BaseDialog,
    FormButton,
    FormInput,
    FormMapSearchBox,
  },
  data() {
    return {
      isDirty: false,
      locationTitle: '',
      locationAddress: {
        fullAddress: '',
        coordinates: {
          latitude: null,
          longitude: null,
        },
      },
      selectedLocation: null,
    };
  },
  computed: {
    isEditMode() {
      return this.selectedLocation !== null;
    },
    isFormInvalid() {
      return !this.locationTitle || !this.locationAddress.fullAddress;
    },
  },
  methods: {
    ...mapActions('tenantLocations', ['addTenantLocation', 'editTenantLocation']),
    openDialog(selectedLocalisation) {
      this.selectedLocation = selectedLocalisation;
      if (this.isEditMode) {
        this.locationTitle = this.selectedLocation.locationLabel;
      } else {
        this.locationTitle = '';
      }
      this.locationAddress = {
        fullAddress: '',
        coordinates: {
          latitude: null,
          longitude: null,
        },
      };
      this.$refs.dialog.openModal();
      setTimeout(() => {
        const inputElement = this.$refs.locationTitle.$el.querySelector('input');
        if (inputElement) {
          inputElement.focus();
        }
      }, 200);
    },

    closeDialog() {
      this.isDirty = false;
      this.$refs.mapSearch.clear();
      this.$refs.dialog.isModalOpen = false;
    },

    onInputChange() {
      this.isDirty = true;
    },

    onAddressSelected(newAddress) {
      this.locationAddress = newAddress;
    },

    onSubmit() {
      if (this.isEditMode) {
        const updatedLocation = {
          locationLabel: this.locationTitle,
          mapLocation: {
            addressText: this.locationAddress.fullAddress,
            latitude: this.locationAddress.latitude,
            longitude: this.locationAddress.longitude,
          },
        };
        this.editTenantLocation({ locationId: this.selectedLocation.id, updatedData: updatedLocation })
          .then(() => {
            this.$toast.success(this.$t('page.admin-localisation.edit-success'));
          })
          .catch((error) => {
            this.$toast.error(error);
          });
      } else {
        const newLocation = {
          locationLabel: this.locationTitle,
          mapLocation: {
            addressText: this.locationAddress.fullAddress,
            latitude: this.locationAddress.latitude,
            longitude: this.locationAddress.longitude,
          },
        };

        this.addTenantLocation(newLocation)
          .then(() => {
            this.$toast.success(this.$t('page.admin-localisation.add-success'));
          })
          .catch((error) => {
            this.$toast.error(error);
          });
      }
      this.isDirty = false;
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__localisation {
  .base-dialog__content {
    padding: 32px;
    background: $color-white !important;
  }

  .actions {
    display: flex;
    justify-content: center;
    padding: 2rem;
  }
}
</style>
